import { statusPillClass } from '@/components/status';
import type { SubscriptionRunStatus } from '@/types';

export function StatusPill({ status }: { status: SubscriptionRunStatus }) {
  return <span className={`pill ${statusPillClass(status)}`}>{status}</span>;
}
